<template>
  <div class="login">
    <div class="login-top">
      <img src="@/assets/img/lvlv.png" alt="沃华航旅" @click="pageJumps('BanCar')" class="logo yh-cp" />
      <div class="login-title">欢迎登录</div>
    </div>
    <div class="login-mid">
      <img src="@/assets/img/Login/background.png" alt class="login-mid-img" />
      <div class="login-mid-body">
        <div class="login-mid-body-top">
          <div
            v-for="item in list"
            :key="item.id"
            class="login-mid-body-top-one"
            @click="toggleColor(item.id, item.title)"
            :class="a == item.id ? 'ee' : ''"
          >{{ item.title }}</div>
        </div>
        <div class="login-mid-body-mid" v-if="timu == '密码登录'">
          <img src="@/assets/img/num.png" alt class="login-mid-body-mid-img1" />
          <div class="login-mid-body-mid-line"></div>
          <input type="text" placeholder="请输入手机号" v-model="input1" />
        </div>
        <div class="login-mid-body-mid" v-if="timu == '密码登录'">
          <img src="@/assets/img/mima.png" alt class="login-mid-body-mid-img2" />
          <div class="login-mid-body-mid-line"></div>
          <input type="password" @keyup.enter="goDL" placeholder="请输入密码" v-model="input2" />
        </div>
        <div class="login-mid-body-mid" v-if="timu == '验证码登录'">
          <img src="@/assets/img/num.png" alt class="login-mid-body-mid-img1" />
          <div class="login-mid-body-mid-line"></div>
          <input type="text" placeholder="请输入手机号" v-model="input3" />
        </div>
        <div class="login-mid-body-mid" v-if="timu == '验证码登录'">
          <img src="@/assets/img/yanzheng.png" alt class="login-mid-body-mid-img2" />
          <div class="login-mid-body-mid-line"></div>
          <input  @keyup.enter="goDL" placeholder="请输入验证码" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" v-model="input4" />
          <div class="login-yanzheng" v-show="show" @click="getY">
            获取验证码
            </div>
            <div  >
            <span style="color:rgba(204, 204, 204, 1)" v-show="!show">重新发送({{count}})</span>
            </div>
        </div>
        <div class="denglu" @click="goDL">登录</div>
        <div class="login-mid-body-end">
          <div class="mima" @click="goForget">忘记密码?</div>
          <div class="zhuce">
            <img src="@/assets/img/go.png" alt class />
            <div class="zhuce-title" @click="goRegister">立即注册></div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm-all">
      <div v-for="item in listData" :key="item.id" @click="pageJumps(item.page)" class="btm-all-one yh-cp">{{ item.title }}</div>
    </div>
    <div class="btm-title-top">
      Copyright ©{{year}} 焦作沃华航旅资讯服务有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index">豫ICP备11018117号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      year:'',
      listData: [
          {id:1,title:'首页',page: 'BanCar'},
          {id:2,title:'酒店',page: 'hotelHome'},
          {id:3,title:'旅游',page: 'travelHome'},
          {id:4,title:'用车',page: 'Car'},
          {id:5,title:'景区',page: 'scenicHome'},
          {id:6,title:'攻略',page: 'strategyHome'},
          {id:7,title:'购物',page: 'shopping'},
      ],
      list: [
        { id: 1, title: "密码登录" },
        { id: 2, title: "验证码登录" },
      ],
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      a: 1,
      timu: "密码登录",
      overtime:"",
      show:true,
      count: '',
      timer: null,
    };
  },
  created(){
    this.year = "2020" +"-"+ new Date().getFullYear()
  },
  methods: {
    goForget() {
      this.$router.push({ name: "forgetMm" });
    },
    goRegister() {
      this.$router.push({ name: "register" });
    },
    toggleColor(Id, x) {
      this.a = Id;
      this.timu = x;
    },
    getY() {
      let str = /^1\d{10}$/;
      if (!this.input3) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return false;
      } else if (this.input3.length === 11 && str.test(this.input3)) {
      } else {
        this.$message({
          message: "手机号错误",
          type: "warning",
        });
        return false;
      }

      this.$http
        .get("/send?phone=" + this.input3 + "&type=2")
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
            });
            const TIME_COUNT = 60;
            if (!this.timer){
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if(this.count > 0 && this.count <= TIME_COUNT){
                  this.count--;
                }else{
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null
                }
              },1000)
            }
          }
        })
    },
    goDL() {
      if (this.timu == "密码登录") {
        let str = /^1\d{10}$/;
        if (!this.input1) {
          this.$message({
            message: "请输入手机号",
            type: "warning",
          });
          return false;
        } else if (this.input1.length === 11 && str.test(this.input1)) {
        } else {
          this.$message({
            message: "手机号错误",
            type: "warning",
          });
          return false;
        }

        if (!this.input2) {
          this.$message({
            message: "请输入密码",
            type: "warning",
          });
          return false;
        }
        this.$http
          .post(
            "/pc/customer/pwdLogin?phone=" + this.input1 + "&pwd=" + this.input2
          )
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.$store.dispatch("setToken", res.data.token);
               this.$router.replace({name:'HelloWorld'})
              /* this.$router.go(-1); */
            }
            if (res.code == 2012) {
              this.$message({
                message: "密码错误",
                type: "warning",
              });
            }
            if (res.code == 2035) {
              this.$message({
                message: "密码未设置,请设置登录密码",
                type: "warning",
              });
              this.$router.push({ name: "forgetMm" });
            }
            if (res.code == 2026) {
              this.$message({
                message: "手机号尚未注册",
                type: "warning",
              });
            }
          })
      } else if (this.timu == "验证码登录") {
        let str = /^1\d{10}$/;
        if (!this.input3) {
          this.$message({
            message: "请输入手机号",
            type: "warning",
          });
          return false;
        } else if (this.input3.length === 11 && str.test(this.input3)) {
        } else {
          this.$message({
            message: "手机号错误",
            type: "warning",
          });
          return false;
        }
        if (!this.input4) {
          this.$message({
            message: "请输入验证码",
            type: "warning",
          });
          return false;
        }
        this.$http
          .get(
            "/pc/customer/codeLogin?phone=" +
              this.input3 +
              "&verify=" +
              this.input4
          )
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.$store.dispatch("setToken", res.data.token);
              this.$router.replace({name:'HelloWorld'})
              /* this.$router.go(-1); */
            }
            if (res.code == 2013) {
              this.$message({
                message: "验证码错误",
                type: "warning",
              });
              return false;
            }
            if (res.code == 2014) {
              this.$message({
                message: "验证码已过期",
                type: "warning",
              });
              return false;
            }
             if (res.code == 2026) {
              this.$message({
                message: "手机号尚未注册",
                type: "warning",
              });
              return false;
            }
          })
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">
a{color:#333;}
 a:hover, a:visited, a:link, a:active {
    color:#333;
}
.login-top {
  width: 100%;
  height: 160px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.login-title {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
}
.login-mid {
  width: 100%;
  height: 700px;
  position: relative;
}
.login-mid-img {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
}
.login-mid-body {
  width: 476px;
  height: 484px;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  position: absolute;
  left: 59%;
  top: 100px;
}
.login-mid-body-top {
  width: 100%;
  height: 127px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  display: flex;
  align-items: center;
}
.login-mid-body-top-one {
  flex: 1;
  text-align: center;
  height: 127px;
  line-height: 127px;
  cursor: pointer;
}
.ee {
  color: #00b4ff;
}
.login-mid-body-mid {
  display: flex;
  align-items: center;
  margin: 20px 35px;
  width: 396px;
  height: 64px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: 4px;
  position: relative;
}
.login-mid-body-mid input{
  width: 150px;
  height: 100%;
}
.login-yanzheng {
  position: absolute;
  cursor: pointer;
  width: 112px;
  height: 36px;
  background: rgba(0, 180, 255, 1);
  border-radius: 4px;
  top: 13px;
  right: 10px;
  text-align: center;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.login-mid-body-mid-img1 {
  width: 23px;
  height: 28px;
  padding: 10px;
}
.login-mid-body-mid-img2 {
  width: 23px;
  height: 26px;
  padding: 10px;
}
.login-mid-body-mid-line {
  width: 2px;
  height: 26px;
  background-color: rgba(204, 204, 204, 1);
  margin-right: 20px;
}
.login-mid-body-mid input {
  width: 200px;
  border: none;
  outline: none;
}
.login-mid-body-mid input::-webkit-input-placeholder {
  color: #aab2bd;
  font-size: 16px;
}
.denglu {
  width: 398px;
  height: 64px;
  background: linear-gradient(
    90deg,
    rgba(0, 180, 255, 1),
    rgba(16, 218, 255, 1)
  );
  border-radius: 8px;
  line-height: 64px;
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 254, 254, 1);
  margin: 20px 35px;
  cursor: pointer;
}
.login-mid-body-end {
  margin: 0px 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mima {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  cursor: pointer;
}
.zhuce {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.zhuce img {
  width: 16px;
  height: 16px;
}
.zhuce-title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  cursor: pointer;
}
.btm-all {
  width: 80%;
  height: 100px;
  margin-left: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btm-all-one {
  width: 100px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  border-right: 1px solid rgba(153, 153, 153, 1);
}
.btm-all-one:nth-child(7) {
  border: none;
}
.btm-title-top {
  width: 80%;
  margin-left: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  height: 50px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue